module.exports = __webpack_public_path__ + "static/media/slide-1.9cadef2f.jpg";